module.exports = __webpack_public_path__ + "static/hero5-b5e9b0a7abf67f353803209a1dae6cc3.jpg";